<div class="wrapper">

  <div id="content">

  <pre>{{ aboutme | json }}</pre>
</div>
</div>